'use client'

import useRequest from '../useRequest'

const usePageId = () => useRequest().pageId

export default usePageId
